
// require('./bootstrap');
window.$ = window.jQuery = require( 'jquery' );;

// bootstrap datatables...
// require( 'datatables.net-bs4' );
// require( 'dteditor/js/dataTables.editor.js');  // harus dipisah: eror is not a constructor
// require( 'dteditor/js/editor.bootstrap4.min.js');
// require( 'datatables.net-buttons-bs4' ); // harus dipisah ngak muncul tombolnya
// require( 'datatables.net-buttons/js/buttons.colVis.js' );
// require( 'datatables.net-buttons/js/buttons.flash.js' );
// require( 'datatables.net-buttons/js/buttons.html5.js' );
// require( 'datatables.net-buttons/js/buttons.print.js' );
// require( 'datatables.net-select-bs4' ); // harus dipisah masih bug unknow type button select
require( 'datatables.net-autofill-bs4' );
require( 'datatables.net-colreorder-bs4' );
require( 'datatables.net-fixedcolumns-bs4' );
require( 'datatables.net-fixedheader-bs4' );
require( 'datatables.net-responsive-bs4' );
require( 'datatables.net-rowreorder-bs4' );
require( 'datatables.net-scroller-bs4' );
require( 'datatables.net-rowgroup-bs4' );
// bs4 no js - require direct component
// styling only packages for bs4
require( 'datatables.net-keytable' );
// pdfMake
// var pdfMake = require('pdfmake/build/pdfmake.js');
// var pdfFonts = require('pdfmake/build/vfs_fonts.js');
// pdfMake.vfs = pdfFonts.pdfMake.vfs;



// WEBPACK FOOTER //
// ./resources/assets/js/appdt.js